import React from "react";
import MasterLayout from "../otherImages/MasterLayout";
import UsersDataTable from "../components/UsersDataTable";
import DefaultTopBar from "../components/DefaultTopBar";

const ManageClients = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        <DefaultTopBar
            title="Users"
            desc="View edit, and manage users accounts efficiently."
        />

        {/* TableDataLayer */}
        <UsersDataTable />

      </MasterLayout>

    </>
  );
};

export default ManageClients; 
